import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import TextInput from "../../../../../components/inputs/textInput/TextInput";
import {
  fetchSupportChats,
  nextChatPage,
  resetChatPagination,
  setActiveSupportChat,
  setActiveUserId,
} from "../../../../../features/supportChat/supportChatSlice";
import useDebouncedSearch from "../../../../../hooks/useDebouncedSearch";
import useInfiniteScroll from "../../../../../hooks/useInfiniteScroll";
import styles from "./chatList.module.css";
import OneChat from "./oneChat/OneChat";

const ChatList = () => {
  const location = useLocation();
  const { userName } = location.state || {};

  const [query, setQuery] = useState(userName ? userName : "");

  const handleChatClick = (chat) => {
    dispatch(setActiveSupportChat(chat._id));
    dispatch(setActiveUserId(chat?.userId));
  };

  const dispatch = useDispatch();

  const { chats, chatsPagination, fetchAllChatsStatus } = useSelector(
    (state) => state.supportChat
  );
  const scrollRef = useRef();

  useInfiniteScroll({
    ref: scrollRef,
    hasMore: chatsPagination.hasMore,
    isLoading: fetchAllChatsStatus === "loading",
    onLoadMore: () => {
      dispatch(nextChatPage());
      dispatch(fetchSupportChats());
    },
  });

  const handleDebouncedSearch = useDebouncedSearch({
    delay: 500,
    onSearch: (value) => {
      dispatch(resetChatPagination());
      dispatch(fetchSupportChats({ page: 1, limit: 10, username: value }));
    },
    onReset: () => {
      dispatch(resetChatPagination());
      dispatch(fetchSupportChats({ page: 1, limit: 10 }));
    },
  });

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    handleDebouncedSearch(value);
  };

  useEffect(() => {
    if (!query.trim()) {
      dispatch(resetChatPagination());
      dispatch(fetchSupportChats({ page: 1, limit: 10 }));
    }
  }, [dispatch, query]);

  useEffect(() => {
    if (!userName) return;

    handleDebouncedSearch(userName);
  }, [userName]);

  useEffect(() => {
    if (userName && chats.length > 0) {
      handleChatClick(chats[0]);
    }
  }, [chats, userName]);

  return (
    <div className={styles.chatListWrapper}>
      <div className={styles.searchWrapper}>
        <TextInput
          height="44px"
          width="100%"
          borderRadius="10px"
          bordered
          placeHolder="البحث عن شات"
          bgColor="grey"
          value={query}
          onChange={handleChange}
        />
      </div>

      <div className={styles.availableChats} ref={scrollRef}>
        {chats?.map((chat) => {
          return (
            <OneChat
              handleChatClick={handleChatClick}
              chat={chat}
              key={chat?._id}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ChatList;
